import React from 'react';
import { Blocks, DollarSign, Users, Sparkles, TrendingUp, TrendingDown, AlertTriangle } from 'lucide-react';

const kpis = [
  {
    id: 'kpi-blocks-sold',
    label: 'Blocks Claimed',
    value: '2,847,293',
    sub: 'of 6,000,000 total',
    change: '+12,847 today',
    trend: 'up',
    icon: Blocks,
    color: 'text-primary',
    bgColor: 'bg-primary/10',
    borderColor: 'border-primary/20',
  },
  {
    id: 'kpi-revenue',
    label: 'Total Revenue',
    value: '$14,236,465',
    sub: 'at $5 per block',
    change: '+$64,235 today',
    trend: 'up',
    icon: DollarSign,
    color: 'text-success',
    bgColor: 'bg-success/10',
    borderColor: 'border-success/20',
  },
  {
    id: 'kpi-users',
    label: 'Registered Users',
    value: '12,483',
    sub: '847 new this week',
    change: '+127 today',
    trend: 'up',
    icon: Users,
    color: 'text-accent',
    bgColor: 'bg-accent/10',
    borderColor: 'border-accent/20',
  },
  {
    id: 'kpi-miracles',
    label: 'Miracles Delivered',
    value: '2,847,293',
    sub: '100% delivery rate',
    change: '3 failed · needs review',
    trend: 'warn',
    icon: Sparkles,
    color: 'text-warning',
    bgColor: 'bg-warning/10',
    borderColor: 'border-warning/20',
  },
];

export default function AdminKPICards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
      {kpis?.map((kpi) => (
        <div key={kpi?.id} className={`rounded-xl p-6 border ${kpi?.borderColor} cosmic-card`}>
          <div className="flex items-start justify-between mb-4">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${kpi?.bgColor}`}>
              <kpi.icon size={18} className={kpi?.color} />
            </div>
            {kpi?.trend === 'up' && <TrendingUp size={14} className="text-success mt-1" />}
            {kpi?.trend === 'down' && <TrendingDown size={14} className="text-danger mt-1" />}
            {kpi?.trend === 'warn' && <AlertTriangle size={14} className="text-warning mt-1" />}
          </div>
          <p className="text-xs text-muted-foreground uppercase tracking-widest mb-1">{kpi?.label}</p>
          <p className={`font-display text-3xl font-bold metric-number ${kpi?.color} mb-1`}>{kpi?.value}</p>
          <p className="text-xs text-muted-foreground mb-2">{kpi?.sub}</p>
          <p className={`text-xs font-medium ${kpi?.trend === 'warn' ? 'text-warning' : 'text-success'}`}>
            {kpi?.change}
          </p>
        </div>
      ))}
    </div>
  );
}